<div class="form-container">

  <ng-container *ngFor="let dropdown of dropdowns; let i = index">
    <mat-form-field *ngIf="dropdown.showDropdown">
      <mat-label>{{ dropdown.selectionPoint.fieldLabel }}</mat-label>
      <mat-select (selectionChange)="onSelectValue(i, $event.value)">
        <mat-option *ngFor="let option of dropdown.options" [value]="option">{{ option.displayValue }}</mat-option>
      </mat-select>
    </mat-form-field>
  </ng-container>

</div>